/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoSysMaintenanceUpdateRequest model module.
 * @module model/SystemControllerDtoSysMaintenanceUpdateRequest
 * @version 1.0
 */
class SystemControllerDtoSysMaintenanceUpdateRequest {
    /**
     * Constructs a new <code>SystemControllerDtoSysMaintenanceUpdateRequest</code>.
     * @alias module:model/SystemControllerDtoSysMaintenanceUpdateRequest
     */
    constructor() { 
        
        SystemControllerDtoSysMaintenanceUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoSysMaintenanceUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoSysMaintenanceUpdateRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoSysMaintenanceUpdateRequest} The populated <code>SystemControllerDtoSysMaintenanceUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoSysMaintenanceUpdateRequest();

            if (data.hasOwnProperty('maintenanceNo')) {
                obj['maintenanceNo'] = ApiClient.convertToType(data['maintenanceNo'], 'Number');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoSysMaintenanceUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoSysMaintenanceUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['version'] && !(typeof data['version'] === 'string' || data['version'] instanceof String)) {
            throw new Error("Expected the field `version` to be a primitive type in the JSON string but got " + data['version']);
        }

        return true;
    }


}



/**
 * @member {Number} maintenanceNo
 */
SystemControllerDtoSysMaintenanceUpdateRequest.prototype['maintenanceNo'] = undefined;

/**
 * @member {Date} startedAt
 */
SystemControllerDtoSysMaintenanceUpdateRequest.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
SystemControllerDtoSysMaintenanceUpdateRequest.prototype['endedAt'] = undefined;

/**
 * @member {String} title
 */
SystemControllerDtoSysMaintenanceUpdateRequest.prototype['title'] = undefined;

/**
 * @member {String} content
 */
SystemControllerDtoSysMaintenanceUpdateRequest.prototype['content'] = undefined;

/**
 * @member {String} version
 */
SystemControllerDtoSysMaintenanceUpdateRequest.prototype['version'] = undefined;






export default SystemControllerDtoSysMaintenanceUpdateRequest;

